import AbstractRequestTask from "../../AbstractRequestTask";
import Launcher from '../../../apa/Launcher';
import { ENABLE_MODAL_RETRIES } from '../../../RequestManagerConstants';

class LogoutOttV1Task extends AbstractRequestTask {
    constructor(params = {}) {
        super();
        this.ownParams = params;
    }

    getParams() {
        const params = super.getParams();
        delete params.api_version;
        delete params.format;
        delete params.user_token;
        delete params.device_so;
        delete params.device_name;
        return Object.assign({}, params, this.ownParams);
    }

    getUrl() {
      const http = "https://";
      const url = Launcher.get("akamai_mfwk");
        return `${http}${url}/services/user/v1/ott/logout`;
    }

    getShowErrorModal(){
        return ENABLE_MODAL_RETRIES;
    }

}

export default LogoutOttV1Task;



// WEBPACK FOOTER //
// ./src/requests/tasks/user/v1/LogoutOttV1Task.js